/* eslint-disable */
import '@backstage/cli/asset-types';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
/* eslint-enable */

// TODO: removed old interceptors and added token call to all of the api calls. We should look into adding interceptors back in a way that allows for the id hook to be called.
// Link to a possible soluition https://dev.to/arianhamdi/react-hooks-in-axios-interceptors-3e1h

const root = createRoot(document.getElementById('root'));
root.render(<App />);
